<template>
  <div class="introduction">
    <div v-if="!pc" class="m">
      <topM :lang="lang"></topM>
    </div>
    <div v-else class="pc">
      <topPc></topPc>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    topM: () => import("@/components/top_m"),
    topPc: () => import("@/components/top"),
  },
  props: ["pc"],
};
</script>

<style lang="scss" scoped>
.pc {
  min-width: 1280px;
}
</style>
